export const iconFontAwesomeSciencefictionOldRepublic = (
	<i className="fa-solid fa-old-republic"></i>
);
